<template>
    <div>
        <v-dialog v-model="show" max-width="550px" >
            <v-card>
                <v-card-title class="headline">Histórico</v-card-title>

                <v-divider/>

                <v-card-text>
                    <v-list two-line subheader>
                        <v-list-item v-for="item in lista" :key="`hist_${item.id}`">
                            <v-list-item-content>
                                <v-list-item-title v-text="`${item.descricao}`"></v-list-item-title>
                                <v-list-item-subtitle v-text="item.datahora"></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <p v-show="lista.length == 0">Histórico vázio!</p>
                </v-card-text>
            </v-card>
        </v-dialog>
        
    </div>
</template>

<script>
    export default {
        props: {
            lista: Array,
            fechar: Function,
            showHistorico: Boolean
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            open() {
                this.show = true;
            }
        },
        watch: { 
            showHistorico: function(newVal) {
                if (newVal)
                    this.open()
            }
        }
    }
</script>
